(ns frontend.view.settings2.guests.view
  (:require [common.localization :as loc]
            [frontend.routing :as routing] 
            [frontend.page-components.zap-toolbar :as zap-toolbar]
            [frontend.view.settings2.guests.db :as db]
            [frontend.page-components.default-page-layout :as default-page-layout]
            [ui.components.breadcrumbs.view :as breadcrumbs]))

(defn breadcrumbs
  []
  [breadcrumbs/container
   [breadcrumbs/item
    {:on-click (fn [e]
                 (routing/set-view! [:account-settings :tab-key "security"]))}
    (loc/tr :settings/account-settings)]
   [breadcrumbs/item
    {:active? true}
    (loc/tr :settings/guests)]])


(defn advertisement []
  [:div
   {:class "mx-auto p-4 container"}
   [:div
    {:class "flex flex-col gap-3"}
    [:p "Collaborate & get more done with less effort together with guest users!"]
    [:p
     [:strong "Buy-side guests"]
     " (e.g. staff from the business units, venture partners or buy-side legal team) can help you\nmake more informed decisions and give valuable second opinions."]
    [:p
     [:strong "Sell-side guests"]
     " (e.g. target company CEO/CFO or their bankers) can handle the mundane tasks of\nmanual data entry from you and collaborate on deals in a secure environment."]
    [:p "This feature is available in our premium plans."]
    [:p "Please reach out to your contact person or  "
     [:a {:href   "mailto:sales@zapflow.com"
          :target "_blank"}
      "sales@zapflow.com"]
     "  to learn more."]]])

(defmethod routing/render-view :new-settings/guests [_]
  [default-page-layout/view
   [:<>
    [zap-toolbar/view db/state breadcrumbs nil nil]
    [advertisement]]])
